'use strict';

var React = require('react');

var getReadableTime = function (timeLeftMs) {
    if (timeLeftMs <= 0) {
        return '00:00';
    }
    var seconds = timeLeftMs / 1000;
    var m = Math.floor((seconds % 3600) / 60)
        .toString()
        .padStart(2, '0');
    var s = Math.floor(seconds % 60)
        .toString()
        .padStart(2, '0');
    return m + ":" + s;
};
var getTimeLeft = function (isoTimestamp) {
    var now = new Date();
    var targetTime = new Date(isoTimestamp);
    var timeLeftMs = targetTime.getTime() - now.getTime();
    if (Number.isNaN(timeLeftMs)) {
        return '00:00';
    }
    return getReadableTime(timeLeftMs);
};
function useExpiryTime(expiryTime, callback) {
    var _a = React.useState(getTimeLeft(expiryTime)), timeLeft = _a[0], setTimeLeft = _a[1];
    var decrementTime = React.useCallback(function () {
        var currentTimeLeft = getTimeLeft(expiryTime);
        if (callback) {
            callback();
        }
        setTimeLeft(currentTimeLeft);
    }, [callback, expiryTime]);
    React.useEffect(function () {
        var timer = setInterval(decrementTime, 1000);
        return function () { return clearInterval(timer); };
    }, [decrementTime, expiryTime]);
    return timeLeft;
}

exports.useExpiryTime = useExpiryTime;
//# sourceMappingURL=useExpiryTime-b8edb931.js.map
